module.exports = __webpack_public_path__ + "media/spa/pc_recommended_job_offers_banner-6d3f707e.svg";